import { Component, EventEmitter, Input, Output, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslateService } from '@services/translate.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { StandingsDialogComponent } from './standings.dialog.component';
import { DataService } from '@services/data.service';
import { environment } from '@environments/environment';
import { debounce } from 'lodash';

@Component({
  selector: 'cashout-component',
  templateUrl: '../sharedTemplates/cashout.component.html',
})
export class CashoutComponent implements AfterViewInit, OnDestroy {
  isMobileView = false;
  cashoutInfoButtonState = false;
  public openWidget: ((id: number) => void) & { cancel: () => void };
  @Input() inputStateId = 1;
  public isRestoreButton: number[] = [];
  protected readonly environment = environment;

  constructor(
    private _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    private _DataService: DataService,
    public dialog: MatDialog,
    private _webWorkerService: WebWorkerService,
    private cdRef: ChangeDetectorRef,
    private _TranslateService: TranslateService
  ) {
    this.openWidget = debounce(
      id => {
        if (this.clickedMatchId === id) {
          this.clickedMatchId = null;
        } else {
          //Livetracker komponent state yönetimi yapabilmek için 100ms delay eklendi.
          this.clickedMatchId = null;
          setTimeout(() => {
            this.clickedMatchId = id; // Yeni tıklanan maçı aç
          }, 100);
        }
        this.cdRef.detectChanges();
      },
      200,
      { leading: true, trailing: true }
    );

    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  }
  @Output() eventDetailEventId = new EventEmitter();

  @Output() cashoutLengthListener: EventEmitter<any> = new EventEmitter();
  isLive = false;

  isJacktimeActive = environment?.isJacktimeActive || false;

  cashoutSlipDetailList = [];
  cashOutValue = 0;
  cashoutIsActive = false;
  today = new Date();
  cashoutApproveSlipId = 0;
  cashoutSubmitMessageIsActive = false;
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  oldCashoutSlipsList;
  lastSlipId;
  source;
  cashoutWatch;
  wildCardStep = '';
  selectedItems = [];

  ngAfterViewInit() {
    this._DataService.activeList.getSlipCashOutValues = true;
    if (this.isMobileView) {
      if (this._UserHelper.isSignedIn) {
        this._DataService.removeDataGetter('getSlipCashOutList');
        this._DataService.setDataGetter('getSlipCashOutList', 15);
      }
      {
        this.subscriptionsToStopOnDestroy.push(
          this._UserHelper.signInListener.subscribe(s => {
            if (s === true) {
              this._DataService.setDataGetter('getSlipCashOutList', 15);
            } else {
              this._DataService.removeDataGetter('getSlipCashOutList');
              this._DataService.removeDataGetter('getSlipCashOutValues');
            }
          })
        );
      }
    } else {
      if (this._UserHelper.isSignedIn) {
        this._DataService.setDataGetter('getSlipCashOutList', 15);
      } else {
        this._UiHelper.SetRightMenuState('open');
        this.subscriptionsToStopOnDestroy.push(
          this._UserHelper.signInListener.subscribe(s => {
            if (s === true) {
              this._DataService.setDataGetter('getSlipCashOutList', 15);
            } else {
              this._DataService.removeDataGetter('getSlipCashOutList');
              this._DataService.removeDataGetter('getSlipCashOutValues');
            }
          })
        );
      }
    }

    this._UiHelper.setNavbarTitle('Cashout', true);
  }

  getCashoutSlipDetail(slipId) {
    this._ApiService.getCashoutValueExternal(slipId).then(cashoutValue => {
      if (cashoutValue == undefined) {
        return;
      }
      if (cashoutValue == '') {
        return;
      }

      this.cashoutSlipDetailList = cashoutValue;
      if (cashoutValue != '' && this.cashoutSlipDetailList.length != 0) {
        if (cashoutValue[0] != undefined) {
          if (cashoutValue[0] != undefined) {
            this.cashOutValue = cashoutValue[0].CashOutValue;
          }
        }
      }
    });
  }

  cashoutApprove(id) {
    this.cashoutApproveSlipId = id;
  }

  cashoutModify() {
    this.cashoutApproveSlipId = 0;
  }

  cashOut(slipId, cashOutValue) {
    if (!cashOutValue) {
      return;
    }
    const cv = this._DataHelper.cashoutSlipsList.filter(ocv => ocv.SlipId == slipId);

    const currentCashoutSlip = this._DataHelper.cashoutSlipsList.find(i => i.SlipId === slipId);
    const isLiveMatch = currentCashoutSlip.isLive;
    if (cv != undefined && cv.length > 0) {
      cv[0].cashoutSubmitMessageIsActive = true;
    }
    this._UiHelper.setLoadingDialog(true);
    setTimeout(
      () => {
        this._ApiService.cashOutPay(slipId, cashOutValue).then(result => {
          const cv = this._DataHelper.cashoutSlipsList.filter(ocv => ocv.SlipId == slipId);
          if (cv != undefined && cv.length > 0) {
            cv[0].cashoutSubmitMessageIsActive = false;
          }
          this._UiHelper.setLoadingDialog(false);
          if (result.code == 'error') {
            this._DataService.fireApiCall('getSlipCashOutList');
            if (!['JT_SellBet_FAILED_CASHOUT_VALUE_TOO_HIGH', 'JT_SellBet_FAILED_BET_ALREADY_SOLD'].includes(result.message)) {
              this._UiHelper.errorSnackBar(result.message, '');
            }
            this.cashoutApproveSlipId = 0;
          } else if (result.code == 'errorcode') {
            const t_message = this._TranslateService.instant(result.message);
            this._UiHelper.errorSnackBar(t_message, '');
            this._DataService.fireApiCall('getSlipCashOutList');
            this.cashoutApproveSlipId = 0;
          } else if (result.code == 'success') {
            const t_message = this._TranslateService.instant('cashoutsuccess');
            this._UiHelper.successSnackBar(t_message, '');
            this._DataService.fireApiCall('getSlipCashOutList');
            this._ApiService.getClient().then(u => {
              this._UserHelper.setUser(u);
            });
          }
        });
      },
      this.isJacktimeActive ? 0 : isLiveMatch ? 8 * 1000 : 0
    );
  }

  ngOnDestroy() {
    if (this.cashoutWatch != undefined) {
      this.cashoutWatch.unsubscribe();
      this.cashoutWatch = null;
      this.source = null;
    }
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }

    this._DataService.activeList.getSlipCashOutValues = false;
    this.openWidget.cancel();
  }

  cashoutButtonActive(status) {
    this.cashoutIsActive = status;
  }

  Cashout_ExpansionPanel_Close(id = 0) {
    if (id == this.lastSlipId) {
      this.lastSlipId = 0;
      this.clickedMatchId = null;
    }
    this.cashoutButtonActive(false);
    this.isRestoreButton = this.isRestoreButton.filter(x => x != id);
  }

  Cashout_ExpansionPanel_Open(id = 0) {
    this.cashoutSlipDetailList = [];
    this.lastSlipId = id;
    this.clickedMatchId = null;
    this.isRestoreButton = [...this.isRestoreButton, id];
    this.selectedItems = [];
    this.wildCardStep = '';
  }

  goLiveEventDetail(e) {
    this._router.navigate(['/liveeventdetail', e]);
  }

  goEventDetail(e) {
    this._router.navigate(['/eventdetail', e]);
  }

  clickedMatchId: number | null = null;

  goDetail(selectedEvent) {
    if (selectedEvent.IsLive == true) {
      if (selectedEvent.MatchStatus == 'Ende') {
        this.openStatsDialog(selectedEvent.BetradarMatchId);
        return;
      }

      this._DataHelper.selectedMatch = { GroupName: '', IsoName: '' };
      this._DataHelper.selectedMatch.GroupName = this._TranslateService.instant('MyBets');
      this._DataHelper.selectedMatch.IsoName = '';
      this.goLiveEventDetail(selectedEvent.EventId);
    } else {
      if (selectedEvent.MatchStatus == 'Ende') {
        this.openStatsDialog(selectedEvent.BetradarMatchId);
        return;
      }

      if (selectedEvent != undefined && selectedEvent.MatchStatus == '' && selectedEvent.State != '') {
        this.openStatsDialog(selectedEvent.BetradarMatchId);
        return;
      }

      this._DataHelper.selectedMatch = { TournamentName: '', IsoName: '' };

      this._DataHelper.selectedMatch.TournamentName = this._TranslateService.instant('MyBets');

      this._DataHelper.selectedMatch.IsoName = '';

      this.goEventDetail(selectedEvent.EventId);
    }
  }

  // Biten Maçlar için Sportradar Modal açıyor
  openStatsDialog(betradarMatchId) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: betradarMatchId,
        type: 'endedmatchresult',
      },
    });
  }
  cashoutInfo() {
    this._UiHelper.setLoadingDialog(true);
    if (!this.cashoutInfoButtonState) {
      this.cashoutInfoButtonState = true;
      this._ApiService
        .cashoutInfo()
        .then(result => {
          if (result.ResultCode == 1) {
            this._ApiService.getClient2().then().catch();
          } else {
            const t_message_err = this._TranslateService.instant('errorcode3');
            this._UiHelper.errorSnackBar(t_message_err, '');
          }
        })
        .finally(() => {
          this._UiHelper.setLoadingDialog(false);
          this.cashoutInfoButtonState = false;
        });
    }
  }
  slipRestorep1001(slipId: number) {
    this._ApiService.slipRestore(slipId).then(x => {
      this._UiHelper.p1001SetBottomDialogState('open');
    });
    if (this._UiHelper.windowsWidth > 990) {
      this._UiHelper.setCurrentSlipHeaderTabSelected(1);
    }
  }
  setWildCardStep(step) {
    this.wildCardStep = step;
    if (step === 'cancel') {
      this.selectedItems = [];
    } else if (step === 'step2' && this.selectedItems.length === 0) {
      this.wildCardStep = 'step1';
      const t_message_err = this._TranslateService.instant('select_wildcard_match');
      this._UiHelper.errorSnackBar(t_message_err, '');
    }
  }
  customerSlipWildCard() {
    this._UiHelper.setLoadingDialog(true);

    this._ApiService.customerSlipWildCard(this.selectedItems[0].SlipOddId, this.selectedItems[0].OddValue.toString()).then(result => {
      if (result && result[0] && result[0].resultcode === 1) {
        //Success
        this._UiHelper.successSnackBar(result[0].resultmessage, '');
        this.selectedItems = [];
        this.wildCardStep = '';
      } else if (result && result[0] && result[0].resultcode && result[0].resultmessage) {
        this._UiHelper.errorSnackBar(result[0].resultmessage, '');
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
  handleCheckboxChange(cashoutItem) {
    // this.selectedItems = [];
    if (!this.selectedItems.map(item => item.SlipOddId).includes(cashoutItem.SlipOddId)) {
      cashoutItem.selected = true;
      this.selectedItems = [{ SlipOddId: cashoutItem.SlipOddId, OddValue: cashoutItem.OddValue }];
      this.wildCardStep = 'step2';
    } else {
      cashoutItem.selected = false;
      this.selectedItems = [];
      this.wildCardStep = 'step1';
    }
  }

  trackBySlipId(index: number, item: any) {
    return item.SlipId;
  }
  trackByMatchId(index: number, item: any) {
    return item.BetradarMatchId;
  }

  checkSlipOddIdControl(slipOddId) {
    return this.selectedItems?.find(i => i.SlipOddId === slipOddId);
  }
  checkWildCardEnebleControl(itemDetails) {
    return itemDetails?.find(detail => detail.WildCardEneble);
  }
}
